import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-notif" }
const _hoisted_2 = { class: "header-notif__counter" }

import {
	computed,
	onMounted,
	ref,
	watch
} from "vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import HeaderNotificationsModal from "./HeaderNotificationsModal.vue"
import { headerStore } from "@/store/header"
import { rootStore } from "@/store/index"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderNotificationsButton',
  setup(__props) {

const store = headerStore()
const root = rootStore()
const $modal = ref<InstanceType<typeof HeaderNotificationsModal> | null>(null)

const count = computed(() => store.notificationCount.JobCount || 0)

const onClick = () => {
	$modal.value?.open()
}

onMounted(() => {
	if (root.globalJWT) {
		store.loadNotificationCount()
		return
	}
	const unwatch = watch(() => root.globalJWT, (token) => {
		if (token) {
			store.loadNotificationCount()
			unwatch()
		}
	})
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "header-notif__btn",
      title: "Уведомления",
      onClick: onClick
    }, [
      _createVNode(AppIcon, {
        name: "burger",
        width: "20px",
        height: "20px",
        class: "header-notif__icon"
      }),
      _createElementVNode("span", _hoisted_2, _toDisplayString(count.value), 1)
    ]),
    _createVNode(HeaderNotificationsModal, {
      ref_key: "$modal",
      ref: $modal
    }, null, 512)
  ]))
}
}

})